import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';

import {
  BG_1,
  BORDER_2,
  FG_1,
  FG_2,
  FG_3,
  RADIUS_LG,
  RADIUS_MD,
  SHADOW_SM,
} from 'components/upb_viewer_beta/css/betaTokens';
import { bandTier } from 'components/upb_match_explorer/constants';
import { fmtPct } from 'components/upb_match_explorer/format';

function MatchDistributionStrip({ summary }) {
  const bands = summary?.bands || [];
  const total = summary?.total || 0;

  return (
    <div className={css(styles.panel)}>
      <div className={css(styles.head)}>
        <h3 className={css(styles.title)}>Match-rate distribution</h3>
        <span className={css(styles.note)}>{total} partners · rate on active products</span>
      </div>
      <div className={css(styles.strip)}>
        {bands.map(band => (
          <div
            key={band.band}
            className={css(styles.segment)}
            style={{ flexGrow: band.count, backgroundColor: bandTier(band.band).color }}
            title={`${band.label}: ${band.count} partners`}
          >
            {band.count > 0 ? band.count : ''}
          </div>
        ))}
      </div>
      <div className={css(styles.legend)}>
        {bands.map(band => (
          <span key={band.band} className={css(styles.legendItem)}>
            <span
              className={css(styles.dot)}
              style={{ backgroundColor: bandTier(band.band).color }}
            />
            {band.label}&nbsp;<b className={css(styles.legendCount)}>{band.count}</b> ·{' '}
            {fmtPct(band.share)}
          </span>
        ))}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  panel: {
    background: BG_1,
    border: `1px solid ${BORDER_2}`,
    borderRadius: RADIUS_LG,
    boxShadow: SHADOW_SM,
    padding: '20px 22px',
  },
  head: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    flexWrap: 'wrap',
    marginBottom: 16,
  },
  title: { fontSize: 15, fontWeight: 600, color: FG_1, margin: 0 },
  note: { fontSize: 12, color: FG_3 },
  strip: {
    display: 'flex',
    height: 34,
    borderRadius: RADIUS_MD,
    overflow: 'hidden',
    border: `1px solid ${BORDER_2}`,
  },
  segment: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 0,
    fontSize: 12,
    fontWeight: 600,
    color: '#ffffff',
    textShadow: '0 1px 1px rgba(0,0,0,0.18)',
    transition: 'flex-grow 0.4s ease',
  },
  legend: { display: 'flex', gap: 20, flexWrap: 'wrap', marginTop: 14 },
  legendItem: { display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, color: FG_2 },
  legendCount: { color: FG_1, fontWeight: 600 },
  dot: { width: 8, height: 8, borderRadius: '50%' },
});

MatchDistributionStrip.propTypes = {
  summary: PropTypes.shape({
    total: PropTypes.number,
    bands: PropTypes.arrayOf(
      PropTypes.shape({
        band: PropTypes.number,
        label: PropTypes.string,
        count: PropTypes.number,
        share: PropTypes.number,
      }),
    ),
  }),
};

export default MatchDistributionStrip;
